import { render, staticRenderFns } from "./ConfirmTip.vue?vue&type=template&id=1eda2574&"
import script from "./ConfirmTip.vue?vue&type=script&lang=js&"
export * from "./ConfirmTip.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmTip.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports